<style lang="less">
.tab_popover {
	width: 100%;
	&.el-popover {
		padding: 0;
	}
}
</style>
<template>
	<el-popover
		v-model="showStatus"
		:placement="placement"
		:title="title"
		:width="width"
		:trigger="trigger"
		:disabled="disabled"
		popper-class="tab_popover"
	>
		<template>
			<slot name="content" @cancel="cancel" />
		</template>
		<span slot="reference">
			<slot />
		</span>
	</el-popover>
</template>
<script>
export default {
	props: {
		trigger: {
			type: String,
			default: 'hover',
		},
		title: {
			type: String,
			default: '标题',
		},
		placement: {
			type: String,
			default: 'top-start',
		},
		width: {
			type: Number,
			default: 150,
		},
		popperClass: {
			type: String,
			default: 'tab_popover',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			showStatus: false,
		};
	},
	methods: {
		hide() {
			this.showStatus = false;
		},
	},
};
</script>
